import { useNavigate } from 'react-router-dom';
import CardAuthor from './card-author.component';
import CardAuthorSkeleton from './card-author-loading.component';
import { fetchListFeaturedVoices, followUser, unfollowUser } from '../../../../apis/discovery.api';
import { useState } from 'react';
import { useEffect } from 'react';
import { useAtomValue } from 'jotai';
import { profileAtom } from '../../../Settings/atom';
import Cookies from 'js-cookie';
import { DataLayer } from '../../../../utils/data-layer';

const FeaturedVoices = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [listFeaturedVoices, setListFeaturedVoices] = useState([]);
  const [loadingAuthorId, setLoadingAuthorId] = useState(null);

  const profile = useAtomValue(profileAtom);
  const token = Cookies.get(`token`);

  const handleFollowUser = async (id, isCurrentlyFollowing) => {
    try {
      setLoadingAuthorId(id);

      // Track writer follow event when following (not unfollowing)
      if (!isCurrentlyFollowing) {
        const author = listFeaturedVoices.find((user) => user.id === id);
        if (author?.username) {
          DataLayer.trackWriterFollow(author.username);
        }
      }

      if (isCurrentlyFollowing) {
        await unfollowUser(id);
      } else {
        await followUser(id);
      }
      setListFeaturedVoices((prevResults) =>
        prevResults.map((user) =>
          user.id === id ? { ...user, isFollowing: !isCurrentlyFollowing } : user
        )
      );
    } catch (error) {
      console.error('Error updating follow status:', error);
    } finally {
      setLoadingAuthorId(null);
    }
  };

  useEffect(() => {
    const getFeaturedVoices = async () => {
      try {
        setLoading(true);
        const payload = profile?.id && token ? profile?.id : {};
        const result = await fetchListFeaturedVoices({}, payload);
        if (result) {
          setListFeaturedVoices(result?.data || []);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getFeaturedVoices();
  }, []); // eslint-disable-line

  return (
    <div className="">
      <div className="flex items-center justify-between mb-[16px] 2xl:mb-[24px]">
        <h1 className="text-base !text-earth-brown-500 font-[800]">Featured Voices</h1>
        {listFeaturedVoices?.length > 4 && (
          <a
            href="/featured-voices"
            className="text-sm text-growth-green font-[900] cursor-pointer hover:opacity-80 mr-2"
            onClick={(e) => {
              e.preventDefault();
              navigate('/featured-voices');
            }}
          >
            View All
          </a>
        )}
      </div>
      <div className="flex flex-col gap-4">
        {loading && <CardAuthorSkeleton />}
        {listFeaturedVoices?.slice(0, 4).map((item) => (
          <CardAuthor
            key={item.id}
            author={item}
            handleFollowUser={handleFollowUser}
            isHiddenInfo
            isSmallText={true}
            isLoading={loadingAuthorId === item.id}
            isHiddenRankBadge
          />
        ))}
      </div>
    </div>
  );
};

export default FeaturedVoices;
